import { useState, useEffect } from 'react';

export function NewVersionBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener('app-new-version', handler);
    return () => window.removeEventListener('app-new-version', handler);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-primary text-primary-foreground text-center py-2 text-sm">
      En ny version er tilgængelig —{' '}
      <button
        onClick={() => window.location.reload()}
        className="underline font-medium hover:opacity-80"
      >
        Klik for at opdatere
      </button>
    </div>
  );
}
